import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Api_Url } from '../../utils/ApiUrl';

const NotifyMe = ({ className, style, privateSale }) => {
    const { t } = useTranslation();

    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);

    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setShow(false);
        setEmail("");
        setError("");
    };
    const handleShow = () => setShow(true);
    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);

    const handleSubscribe = async () => {
        if (!email || !/\S+@\S+\.\S+/.test(email)) {
            setError("Please enter a valid email address");
            return;
        }
        setLoading(true);
        setError("");
        try {
            const res = await fetch(`${Api_Url}/temp/ps-alert`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, privateSale }),
            });
            const data = await res.json();
            if (res.ok && data.statusCode === 201) {
                handleClose();
                handleShow1();
            } else {
                setError(data.message || "Something went wrong, please try again.");
            }
        } catch (err) {
            setError("Network error. Please try again later.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <a
                className={className}
                style={style}
                onClick={handleShow}
            >
                Notify me
            </a>
            {/* Get Notified Modal */}
            <Modal
                className="common-modal-style followusonx-modal verificationemail-modal getnotified-modal"
                show={show}
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Get Notified</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="verification-modal">
                        <div className="option-field">
                            <label>
                                Sign up to receive an email notification as soon as the sale begins
                            </label>
                            <div className="inside-input">
                                <input
                                    type="text"
                                    placeholder="Enter your email here..."
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className={error ? "error" : ""}
                                />
                            </div>
                            {error && <p className="error-text">{error}</p>}
                        </div>
                        <div className="twice-btnsss">
                            <button
                                className="btn-cancel sscscscscscsc"
                                onClick={handleClose}
                                disabled={loading}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn-green sscscscscscsc"
                                onClick={handleSubscribe}
                                disabled={loading}
                            >
                                {loading ? "Subscribing..." : "Subscribe"}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Success Modal */}
            <Modal
                className="common-modal-style success-modal"
                show={show1}
                onHide={handleClose1}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Success!</Modal.Title>
                </Modal.Header>
                <Modal.Body className="pb-5">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="88"
                        height="88"
                        viewBox="0 0 88 88"
                        fill="none"
                    >
                        <path
                            d="M76.583 37.9845L76.583 11.417L35.1296 51.7939L10.417 34.7697L10.417 59.3998L35.1296 77.583L76.583 37.9845Z"
                            fill="#D1DADD"
                        />
                    </svg>
                    <h6>You're All Set!</h6>
                    <p className="mb-5">We'll notify you as soon as the sale begins..</p>
                    <button className="confirm-btn" onClick={handleClose1}>
                        OK
                    </button>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default NotifyMe
